import api from 'Src/api'

const LIST_USERS_URL = 'v1/users'
const DELETE_USER_URL = 'v1/users/:id'
const DEACTIVATE_USER_URL = 'v1/users/:id/deactivate'
const ACTIVATE_USER_URL = 'v1/users/:id/activate'

export const fetchUsers = async ({ offset = 0, limit = 10 }) => {
  const response = await api.get(LIST_USERS_URL, { params: { offset, limit } })
  const { results, meta } = response.data

  return { users: results, total: meta.total }
}

export const deleteUser = async (id) => {
  await api.delete(DELETE_USER_URL, { urlParams: { id } })
}

export const deactivateUser = async (id) => {
  await api.delete(DEACTIVATE_USER_URL, { urlParams: { id } })
}

export const activateUser = async (id) => {
  await api.post(ACTIVATE_USER_URL, {}, { urlParams: { id } })
}
